import React, { PureComponent } from "react";
import _ from "lodash";
import styled from "styled-components";
import { withRedux } from "../hoc";

const SocialListStyled = styled.ul`
  display: flex;
  flex-direction: row;
  align-items: center;
  li {
    margin: 0 4px;
    &:first-child {
      margin-left: 0;
    }
    &:last-child {
      margin-right: 0;
    }
    i {
      font-size: 30px;
    }
  }
`;

const mapStateToProps = state => {
  return {
    t: _.get(state, "t"),
    languages: _.get(state, "languages"),
    page: _.get(state, "page")
  };
};

const actions = {};

@withRedux(mapStateToProps, actions)
export default class SocialList extends PureComponent {
  render() {
    const { t } = this.props;
    const contact = _.get(this.props, "page.contact.data");
    return (
      <SocialListStyled className="social-list">
        {_.map(_.get(contact, "social_url"), (value, index) => {
          const { platform, url } = value;
          return (
            <li key={index}>
              <a href={t(url)} target="_blank" rel="noopener noreferrer">
                <i className={`fab fa-${t(platform)}`} />
              </a>
            </li>
          );
        })}
      </SocialListStyled>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/SocialList.js